<template>
  <div>
    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="1" ripple> {{ $t("captainsPage.registeredTab") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <RegisteredCaptains />
        </div>
      </v-tab-item>

      <v-tab active-class="tab" :key="2" ripple> {{ $t("captainsPage.pendingTab") }} </v-tab>

      <v-tab-item>
        <div @touchstart.stop @touchmove.stop class="tab-content-wrapper">
          <PendingCaptains />
        </div>
      </v-tab-item>
    </v-tabs>


  </div>
</template>

<script>

import RegisteredCaptains from "@/views/captains/RegisteredCaptains";
import PendingCaptains from "@/views/captains/PendingCaptains";

export default {
  name: "DriversTabs",
  title() {
    return this.$t("captainsPage.driversTitle");
  },
  components: {
    RegisteredCaptains,
    PendingCaptains
  },
  data() {
    return {
      active: 0,
    };
  },
  created() {
    // Deep-link to the Pending tab (e.g. from the dashboard notifications bell).
    if (this.$route.query && this.$route.query.tab === "pending") {
      this.active = 1;
    }
  },
};
</script>

<style scoped>
.tab {
  color: #e21024 !important;
}

.tab-content-wrapper {
  touch-action: pan-y !important;
  height: 100%;
  overflow-y: auto;
}
</style>
